import React from 'react';
import { ChanelConfig } from '../../../../configs/GlobalConfig';
import MessageHub from '../../../../core/signalr/SignalrMessageHub';
import { getQueryParams } from '../../../helpers/Common';
import currentState from './../../../helpers/CurrentState';

const getDisplayName = WrappedComponent => {
  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
};

const mapIndexTab = {
  All: 1,
  HOSE: 2,
  HNX: 3,
  UPCOM: 4,
  VN30: 5,
  HNX30: 6,
};

const withTabAndRealTime = componentName => WrappedComponent => {
  class WithTab extends React.PureComponent {
    constructor(props) {
      super(props);
      const tabFromQuery = mapIndexTab[getQueryParams('exchange')] || '';
      this.state = {
        indexTab:
          tabFromQuery || currentState.get(componentName, 'indexTab') || 1,
        typeTab: props.tab || currentState.get(componentName, 'typeTab') || 1,
      };
    }

    componentDidMount() {
      MessageHub.subscribe(ChanelConfig.TickChanel, this.dispatchDataRealtime);
    }

    componentWillUnmount() {
      MessageHub.unsubscribe(
        ChanelConfig.TickChanel,
        this.dispatchDataRealtime,
      );
    }

    dispatchDataRealtime = data => {
      const { dispatchRealtime } = this.props;
      dispatchRealtime(data);
    };

    changeIndex = indexTab => {
      currentState.add(componentName, 'indexTab', indexTab);
      this.setState({
        indexTab,
      });
    };

    changeType = typeTab => {
      currentState.add(componentName, 'typeTab', typeTab);
      this.setState({
        typeTab,
      });
    };

    render() {
      const { indexTab, typeTab } = this.state;
      return (
        <WrappedComponent
          {...this.props}
          indexTab={indexTab}
          typeTab={typeTab}
          changeIndex={this.changeIndex}
          changeType={this.changeType}
        />
      );
    }
  }

  WithTab.displayName = `WithTabAndRealtime(${getDisplayName(
    WrappedComponent,
  )})`;

  return WithTab;
};

export default withTabAndRealTime;
